import { render, staticRenderFns } from "./ClientChat.vue?vue&type=template&id=4ae7c283&scoped=true"
import script from "./ClientChat.vue?vue&type=script&lang=js"
export * from "./ClientChat.vue?vue&type=script&lang=js"
import style0 from "./ClientChat.vue?vue&type=style&index=0&id=4ae7c283&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae7c283",
  null
  
)

export default component.exports